import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore, selectIsAuthenticated } from '../../stores/authStore'
import { loginPathWithNext } from '../../lib/post-auth-redirect'

export function AuthGuard() {
  const location = useLocation()
  const isAuthenticated = useAuthStore(selectIsAuthenticated)
  const user = useAuthStore(s => s.user)
  const isLoading = useAuthStore(s => s.isLoading)
  const profileComplete = useAuthStore(s => s.profileComplete)
  const signedOut = useAuthStore(s => s.signedOut)

  if (!isAuthenticated) {
    // Carry the requested page through sign-in (password or Google) so it can be reopened,
    // unless this tab just signed out: the next person to sign in starts on their own home.
    const requested = location.pathname + location.search
    const isLanding = location.pathname === '/' || location.pathname === '/dashboard'
    return (
      <Navigate
        to={isLanding || signedOut ? '/login' : loginPathWithNext(requested)}
        replace
        state={{ from: location }}
      />
    )
  }

  // Show loading while user data is being restored
  if (isLoading || !user) {
    return (
      <div className='flex h-full w-full items-center justify-center'>
        <div className='flex items-center space-x-2 text-muted-foreground text-sm'>
          <div className='h-4 w-4 animate-spin rounded-full border-2 border-primary border-t-transparent' />
          <span>Loading...</span>
        </div>
      </div>
    )
  }

  const onboardingRoutes = ['/profile']
  const isProfileRoute = onboardingRoutes.some(path => location.pathname.startsWith(path))

  // Use cached profile completion status for performance (null = unknown, check needed)
  if (profileComplete === false && !isProfileRoute) {
    return <Navigate to='/profile' replace state={{ from: location, profileRequired: true }} />
  }

  return <Outlet />
}

export default AuthGuard
